module.exports = __webpack_public_path__ + "static/media/staffAvatar-placeholder.40f2ba6b.svg";